import icons from '@/assets/icons'
import SJButton from '@/components/SJButton'
import SJCard from '@/components/SJCard'
import SJCell from '@/components/SJCell'
import { useState, useEffect, useMemo } from 'react'
import { getCourseById } from '@/services/course'
import { Course } from '@/services/types/course'
import { DeviceInfoRes, DeviceRes, DevicesRes } from '@/services/types/device'
import { getDevicesName, getUserDevicesV2 } from '@/services/device'
import { getUserCourseLearn } from '@/services/user'
import SJSite from '@/components/SJSite'
import { LearnRes } from '@/services/types/user'
import './index.less'
import { useLocation, useNavigate } from 'react-router-dom'
import { Dialog, Picker } from 'antd-mobile'

const CourseDetail = () => {
  document.title = '课程详情'
  const navigate = useNavigate()
  const { state } = useLocation() as { state: { courseId: string; playerId: string } }
  const { courseId, playerId } = state
  console.log(courseId, playerId)

  const [course, setCourse] = useState<Course>() // 课程
  const [loading, setLoading] = useState(true)

  const [learn, setLearn] = useState<string[]>([]) // 已学习 lessonId[]
  const [devices, setDevices] = useState<DeviceInfoRes[]>([]) // 所以设备
  const [device, setDevice] = useState<DeviceInfoRes>() // 选中设备
  const [value, setValue] = useState<(string | null)[]>()

  useEffect(() => {
    loadDeviceList()
    fetchUserLearn()
  }, [])

  useEffect(() => {
    fetchCourse()
  }, [device])

  const basicColumns = useMemo(() => {
    const columns = devices.map((item) => {
      return { label: item.name, value: item.duid }
    })
    return [columns]
  }, [devices])

  // 学习记录
  const fetchUserLearn = async () => {
    const res = (await getUserCourseLearn({ playerId, courseId })) as unknown as LearnRes
    console.log(res)
    const list: string[] = []
    if (res.courses[0] && res.courses[0].lessons) {
      res.courses[0].lessons.forEach((item) => {
        if (item.isLearningCompleted) {
          list.push(item.lessonId)
        }
      })
    }
    setLearn(list)
  }

  // 课程信息
  const fetchCourse = async () => {
    try {
      setLoading(true)
      const params: any = {
        course_id: courseId,
        // course_id: 'C-073e4ed6-2d0f-43f9-862d-133cdfa4b70d',
      }
      if (device?.duid) {
        params['device_sn'] = device.duid
      }
      const res = (await getCourseById(params)) as unknown as Course
      console.log(res)
      setCourse(res)
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  // 请求设备列表
  const loadDeviceList = async () => {
    getUserDevicesV2()
      .then((res) => {
        const { list } = res as unknown as DevicesRes
        if (list.length) {
          const devicesArr: string[] = []
          for (let i = 0; i < list.length; i++) {
            const element = list[i] as unknown as DeviceRes
            devicesArr.push(element.deviceId)
          }
          getDevicesName(devicesArr.toString()).then((resp) => {
            console.log('getDevicesName ', resp)
            const _devices = resp as unknown as DeviceInfoRes[]
            setDevices(_devices)
            setDevice(_devices[0])
          })
        } else {
          setDevices([])
        }
      })
      .catch((err) => {
        console.error(err)
      })
  }

  const isLearned = (id: string) => {
    return learn.includes(id)
  }

  // const onDeviceChange = (e: any) => {
  //   setDevice(devices[e.detail.value])
  // }

  // 解锁课程
  const goPay = () => {
    if (device && device.duid) {
      navigate('/course/order', { state: { courseId: course?.course_id, deviceId: device.duid } })
    } else {
      Dialog.confirm({
        title: '未找到设备',
        content: '是否立即添加设备？',
        cancelText: '以后再说',
        confirmText: '立即添加',
        onConfirm: () => {
          // Taro.navigateTo({
          //   url: '/packageSettings/pages/addWifi/index',
          // })
        },
      })
    }
  }

  return (
    <div className="course-detail">
      {course ? (
        <div className="main">
          <div className="top">
            <div className="flex-1">
              <div className="title">{course.course_name}</div>
              {device?.name && <div className="device">当前设备：{device?.name}</div>}
            </div>
            {devices.length > 0 && (
              <Picker columns={basicColumns} value={value} onConfirm={setValue}>
                {(items, { open }) => {
                  return (
                    <div className="switch hoverClass" onClick={open}>
                      <img src={icons.IconSwitch} alt="" />
                      <span className="fs12">切换设备</span>
                    </div>
                  )
                }}
              </Picker>
              // <Picker mode="selector" range={devices} rangeKey="name" onChange={onDeviceChange}>
              //   <div className="switch hoverClass">
              //     <img src={icons.IconSwitch} alt=''/>
              //     <span className="fs12">切换设备</span>
              //   </div>
              // </Picker>
            )}
          </div>
          <div className="desc">{course.course_description}</div>
          <div className="progress">
            <span className="label">完成度：</span>
            <span className="value step">{learn.length}</span>
            <span className="value">&nbsp;/&nbsp;{course.lessons.length}</span>
          </div>
          <SJCard className="list">
            {course.lessons &&
              course.lessons.length > 0 &&
              course.lessons.map((item, index) => {
                return (
                  <SJCell
                    title={index + 1 + '. ' + item.lesson_name}
                    key={index}
                    detail={
                      isLearned(item.lesson_id) ? (
                        <>
                          <img className="icon-ok" src={icons.IconSuccess} alt="" />
                          <span className="span-ok">已完成</span>
                        </>
                      ) : !item.auth ? (
                        <img className="icon-lock" src={icons.IconLock} alt="" />
                      ) : (
                        <span className="span-no">未完成</span>
                      )
                    }
                  ></SJCell>
                )
              })}
          </SJCard>
          {!course.authorized && !loading && (
            <div className="btn-fixed">
              <SJButton type="primary" size="large" onClick={goPay}>
                解锁全部课程
              </SJButton>
            </div>
          )}
        </div>
      ) : (
        <SJSite />
      )}
    </div>
  )
}

export default CourseDetail
